import {Component, inject} from '@angular/core';
import {PerpetualUsufructBaseInfoForm} from "./forms/perpetual-usufruct-base-info.form";
import {ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {stages} from "../../perpetual-usufruct.routes";
import {ApplicationAppEntityApplicationRead} from "../../../../../../openapi";
import {ApplicationCommonComponent} from "../../../common/application.common.component";
import {StagesComponent} from "../../../../../../common/stages/stages.component";
import {SpinnerComponent} from "../../../../../../common/spinner/spinner.component";
import {ValidationErrorsComponent} from "../../../../../../common/validation-errors/validation-errors.component";
import {ParcelsCrudComponent} from "../../../common/components/parcels/parcels-crud/parcels-crud.component";
import {updateParcels} from "../../../../../../store/actions/application.actions";

@Component({
  selector: 'app-perpetual-usufruct-base-info-section',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    StagesComponent,
    SpinnerComponent,
    ValidationErrorsComponent,
    ParcelsCrudComponent
  ],
  providers: [
    PerpetualUsufructBaseInfoForm
  ],
  templateUrl: './perpetual-usufruct-base-info-section.component.html'
})
export class PerpetualUsufructBaseInfoSectionComponent extends ApplicationCommonComponent {

  public stages: string[] = stages;

  public form: PerpetualUsufructBaseInfoForm = inject(PerpetualUsufructBaseInfoForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      if (this.applicationId) {
        this.updateApplication(
          '',
          this.form.toWriteModel(),
          (app) => {
            this.store$.dispatch(updateParcels({
              currentApp: app,
              parcels: this.form.parcelsValues,
              successFnc: (applicationId: string) => {
                this.router.navigate(
                  ['../dane-identyfikacyjne'],
                  {
                    relativeTo: this.route
                  }
                );
              },
              failureFnc: () => {
              }
            }));
          }
        );
      } else {
        this.createApplication(
          '',
          this.form.toWriteModel(),
          (app) => {
            this.store$.dispatch(updateParcels({
              currentApp: app,
              parcels: this.form.parcelsValues,
              successFnc: (applicationId: string) => {
                this.router.navigate(
                  ['../', app?.uuid, 'dane-identyfikacyjne'],
                  {
                    relativeTo: this.route
                  }
                );
              },
              failureFnc: () => {
              }
            }));
          }
        );
      }
    } else {
      this.form.markAllAsTouched();
    }
  }
}
